import { types } from "./actions";

const initialState = {
  selectForm: {
    typeDoc: "2",
    nroDoc: "",
    capital: "",
    plan: "S&P500 Capital Protegido",
    nameContractor: "",
    dateBirthday: ""
  }
};

const valuesFormReducer = (state = initialState, action) => {
  const {form,type} = action;

  switch (type) {
    case types.saveValuesForm:
      return {
        ...state,
        selectForm:form
      };  
    default:
      return state
  }
};
export default valuesFormReducer;
